import React from "react";

const Pagination = ({ page, totalPages, onPageChange, getPageNumbers }) => {
  const pageNumbers = getPageNumbers();
  const canGoPrevious = page > 1;
  const canGoNext = page < totalPages;

  return (
    <nav aria-label="Page navigation">
      <ul className="pagination justify-content-center">
        {/* Previous Button */}
        <li className={`page-item ${canGoPrevious ? "" : "disabled"}`}>
          <button
            className="page-link"
            onClick={() => canGoPrevious && onPageChange(page - 1)}
            disabled={!canGoPrevious}
          >
            Previous
          </button>
        </li>

        {/* Dynamic Page Numbers */}
        {pageNumbers.map((num) => (
          <li key={num} className={`page-item ${page === num ? "active" : ""}`}>
            <button className="page-link" onClick={() => onPageChange(num)}>
              {num}
            </button>
          </li>
        ))}

        {/* Next Button */}
        <li className={`page-item ${canGoNext ? "" : "disabled"}`}>
          <button
            className="page-link"
            onClick={() => canGoNext && onPageChange(page + 1)}
            disabled={!canGoNext}
          >
            Next
          </button>
        </li>
      </ul>
    </nav>
  );
};

export default Pagination;
